
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("1y3eu", function(module, exports) {
var $120b79595aeaa2fe$var$e, $120b79595aeaa2fe$var$t, $120b79595aeaa2fe$var$n, $120b79595aeaa2fe$var$i, $120b79595aeaa2fe$var$r = function(e, t) {
    return {
        name: e,
        value: void 0 === t ? -1 : t,
        delta: 0,
        entries: [],
        id: "v2-".concat(Date.now(), "-").concat(Math.floor(8999999999999 * Math.random()) + 1e12)
    };
}, $120b79595aeaa2fe$var$a = function(e, t) {
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(e)) {
            if ("first-input" === e && !("PerformanceEventTiming" in self)) return;
            var n = new PerformanceObserver(function(e) {
                return e.getEntries().map(t);
            });
            return n.observe({
                type: e,
                buffered: !0
            }), n;
        }
    } catch (e) {}
}, $120b79595aeaa2fe$var$o = function(e, t) {
    var n = function n(i) {
        "pagehide" !== i.type && "hidden" !== document.visibilityState || (e(i), t && (removeEventListener("visibilitychange", n, !0), removeEventListener("pagehide", n, !0)));
    };
    addEventListener("visibilitychange", n, !0), addEventListener("pagehide", n, !0);
}, $120b79595aeaa2fe$var$u = function(e) {
    addEventListener("pageshow", function(t) {
        t.persisted && e(t);
    }, !0);
}, $120b79595aeaa2fe$var$c = function(e, t, n) {
    var i;
    return function(r) {
        t.value >= 0 && (r || n) && (t.delta = t.value - (i || 0), (t.delta || void 0 === i) && (i = t.value, e(t)));
    };
}, $120b79595aeaa2fe$var$f = -1, $120b79595aeaa2fe$var$s = function() {
    return "hidden" === document.visibilityState ? 0 : 1 / 0;
}, $120b79595aeaa2fe$var$m = function() {
    $120b79595aeaa2fe$var$o(function(e) {
        var t = e.timeStamp;
        $120b79595aeaa2fe$var$f = t;
    }, !0);
}, $120b79595aeaa2fe$var$v = function() {
    return $120b79595aeaa2fe$var$f < 0 && ($120b79595aeaa2fe$var$f = $120b79595aeaa2fe$var$s(), $120b79595aeaa2fe$var$m(), $120b79595aeaa2fe$var$u(function() {
        setTimeout(function() {
            $120b79595aeaa2fe$var$f = $120b79595aeaa2fe$var$s(), $120b79595aeaa2fe$var$m();
        }, 0);
    })), {
        get firstHiddenTime () {
            return $120b79595aeaa2fe$var$f;
        }
    };
}, $120b79595aeaa2fe$export$52489892712e8192 = function(e, t) {
    var n, i = $120b79595aeaa2fe$var$v(), o = $120b79595aeaa2fe$var$r("FCP"), f = function(e) {
        "first-contentful-paint" === e.name && (m && m.disconnect(), e.startTime < i.firstHiddenTime && (o.value = e.startTime, o.entries.push(e), n(!0)));
    }, s = window.performance && performance.getEntriesByName && performance.getEntriesByName("first-contentful-paint")[0], m = s ? null : $120b79595aeaa2fe$var$a("paint", f);
    (s || m) && (n = $120b79595aeaa2fe$var$c(e, o, t), s && f(s), $120b79595aeaa2fe$var$u(function(i) {
        o = $120b79595aeaa2fe$var$r("FCP"), n = $120b79595aeaa2fe$var$c(e, o, t), requestAnimationFrame(function() {
            requestAnimationFrame(function() {
                o.value = performance.now() - i.timeStamp, n(!0);
            });
        });
    }));
}, $120b79595aeaa2fe$var$p = !1, $120b79595aeaa2fe$var$l = -1, $120b79595aeaa2fe$export$fc6227831ee7c7 = function(e, t) {
    $120b79595aeaa2fe$var$p || ($120b79595aeaa2fe$export$52489892712e8192(function(e) {
        $120b79595aeaa2fe$var$l = e.value;
    }), $120b79595aeaa2fe$var$p = !0);
    var n, i = function(t) {
        $120b79595aeaa2fe$var$l > -1 && e(t);
    }, f = $120b79595aeaa2fe$var$r("CLS", 0), s = 0, m = [], v = function(e) {
        if (!e.hadRecentInput) {
            var t = m[0], i = m[m.length - 1];
            s && e.startTime - i.startTime < 1e3 && e.startTime - t.startTime < 5e3 ? (s += e.value, m.push(e)) : (s = e.value, m = [
                e
            ]), s > f.value && (f.value = s, f.entries = m, n());
        }
    }, h = $120b79595aeaa2fe$var$a("layout-shift", v);
    h && (n = $120b79595aeaa2fe$var$c(i, f, t), $120b79595aeaa2fe$var$o(function() {
        h.takeRecords().map(v), n(!0);
    }), $120b79595aeaa2fe$var$u(function() {
        s = 0, $120b79595aeaa2fe$var$l = -1, f = $120b79595aeaa2fe$var$r("CLS", 0), n = $120b79595aeaa2fe$var$c(i, f, t);
    }));
}, $120b79595aeaa2fe$var$T = {
    passive: !0,
    capture: !0
}, $120b79595aeaa2fe$var$y = new Date, $120b79595aeaa2fe$var$g = function(i, r) {
    $120b79595aeaa2fe$var$e || ($120b79595aeaa2fe$var$e = r, $120b79595aeaa2fe$var$t = i, $120b79595aeaa2fe$var$n = new Date, $120b79595aeaa2fe$var$w(removeEventListener), $120b79595aeaa2fe$var$E());
}, $120b79595aeaa2fe$var$E = function() {
    if ($120b79595aeaa2fe$var$t >= 0 && $120b79595aeaa2fe$var$t < $120b79595aeaa2fe$var$n - $120b79595aeaa2fe$var$y) {
        var r = {
            entryType: "first-input",
            name: $120b79595aeaa2fe$var$e.type,
            target: $120b79595aeaa2fe$var$e.target,
            cancelable: $120b79595aeaa2fe$var$e.cancelable,
            startTime: $120b79595aeaa2fe$var$e.timeStamp,
            processingStart: $120b79595aeaa2fe$var$e.timeStamp + $120b79595aeaa2fe$var$t
        };
        $120b79595aeaa2fe$var$i.forEach(function(e) {
            e(r);
        }), $120b79595aeaa2fe$var$i = [];
    }
}, $120b79595aeaa2fe$var$S = function(e) {
    if (e.cancelable) {
        var t = (e.timeStamp > 1e12 ? new Date : performance.now()) - e.timeStamp;
        "pointerdown" == e.type ? function(e, t) {
            var n = function() {
                $120b79595aeaa2fe$var$g(e, t), r();
            }, i = function() {
                r();
            }, r = function() {
                removeEventListener("pointerup", n, $120b79595aeaa2fe$var$T), removeEventListener("pointercancel", i, $120b79595aeaa2fe$var$T);
            };
            addEventListener("pointerup", n, $120b79595aeaa2fe$var$T), addEventListener("pointercancel", i, $120b79595aeaa2fe$var$T);
        }(t, e) : $120b79595aeaa2fe$var$g(t, e);
    }
}, $120b79595aeaa2fe$var$w = function(e) {
    [
        "mousedown",
        "keydown",
        "touchstart",
        "pointerdown"
    ].forEach(function(t) {
        return e(t, $120b79595aeaa2fe$var$S, $120b79595aeaa2fe$var$T);
    });
}, $120b79595aeaa2fe$export$134ed2977d320dfd = function(n, f) {
    var s, m = $120b79595aeaa2fe$var$v(), d = $120b79595aeaa2fe$var$r("FID"), p = function(e) {
        e.startTime < m.firstHiddenTime && (d.value = e.processingStart - e.startTime, d.entries.push(e), s(!0));
    }, l = $120b79595aeaa2fe$var$a("first-input", p);
    s = $120b79595aeaa2fe$var$c(n, d, f), l && $120b79595aeaa2fe$var$o(function() {
        l.takeRecords().map(p), l.disconnect();
    }, !0), l && $120b79595aeaa2fe$var$u(function() {
        var a;
        d = $120b79595aeaa2fe$var$r("FID"), s = $120b79595aeaa2fe$var$c(n, d, f), $120b79595aeaa2fe$var$i = [], $120b79595aeaa2fe$var$t = -1, $120b79595aeaa2fe$var$e = null, $120b79595aeaa2fe$var$w(addEventListener), a = p, $120b79595aeaa2fe$var$i.push(a), $120b79595aeaa2fe$var$E();
    });
}, $120b79595aeaa2fe$var$b = {}, $120b79595aeaa2fe$export$da982ced0ff8a670 = function(e, t) {
    var n, i = $120b79595aeaa2fe$var$v(), f = $120b79595aeaa2fe$var$r("LCP"), s = function(e) {
        var t = e.startTime;
        t < i.firstHiddenTime && (f.value = t, f.entries.push(e), n());
    }, m = $120b79595aeaa2fe$var$a("largest-contentful-paint", s);
    if (m) {
        n = $120b79595aeaa2fe$var$c(e, f, t);
        var d = function() {
            $120b79595aeaa2fe$var$b[f.id] || (m.takeRecords().map(s), m.disconnect(), $120b79595aeaa2fe$var$b[f.id] = !0, n(!0));
        };
        [
            "keydown",
            "click"
        ].forEach(function(e) {
            addEventListener(e, d, {
                once: !0,
                capture: !0
            });
        }), $120b79595aeaa2fe$var$o(d, !0), $120b79595aeaa2fe$var$u(function(i) {
            f = $120b79595aeaa2fe$var$r("LCP"), n = $120b79595aeaa2fe$var$c(e, f, t), requestAnimationFrame(function() {
                requestAnimationFrame(function() {
                    f.value = performance.now() - i.timeStamp, $120b79595aeaa2fe$var$b[f.id] = !0, n(!0);
                });
            });
        });
    }
}, $120b79595aeaa2fe$export$6e8eea9a35032c92 = function(e) {
    var t, n = $120b79595aeaa2fe$var$r("TTFB");
    t = function() {
        try {
            var t = performance.getEntriesByType("navigation")[0] || function() {
                var e = performance.timing, t = {
                    entryType: "navigation",
                    startTime: 0
                };
                for(var n in e)"navigationStart" !== n && "toJSON" !== n && (t[n] = Math.max(e[n] - e.navigationStart, 0));
                return t;
            }();
            if (n.value = n.delta = t.responseStart, n.value < 0 || n.value > performance.now()) return;
            n.entries = [
                t
            ], e(n);
        } catch (e) {}
    }, "complete" === document.readyState ? setTimeout(t, 0) : addEventListener("load", function() {
        return setTimeout(t, 0);
    });
};
module.exports["getFCP"] = $120b79595aeaa2fe$export$52489892712e8192;
module.exports["getCLS"] = $120b79595aeaa2fe$export$fc6227831ee7c7;
module.exports["getFID"] = $120b79595aeaa2fe$export$134ed2977d320dfd;
module.exports["getLCP"] = $120b79595aeaa2fe$export$da982ced0ff8a670;
module.exports["getTTFB"] = $120b79595aeaa2fe$export$6e8eea9a35032c92;

});


//# sourceMappingURL=web-vitals.9cca6cb0.js.map
